var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "notification-settings" }, [
    _c("div", { staticClass: "cards" }, [
      _c("div", { staticClass: "card card-echec" }, [
        _c("header", [
          _c("i", { staticClass: "fa-solid fa-bell" }),
          _vm._v(
            "\n                    " +
              _vm._s(_vm.$t("dash.settings.notifications.echec.title")) +
              "\n                "
          ),
        ]),
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "container-info" }, [
            _c("div", { staticClass: "notification-info" }, [
              _c("h4", [
                _vm._v(
                  _vm._s(
                    _vm.$t("dash.settings.notifications.echec.content.title")
                  )
                ),
              ]),
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.$t("dash.settings.notifications.echec.content.subtitle")
                  )
                ),
              ]),
            ]),
            _c("div", { staticClass: "svg" }, [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "100%",
                    height: "100%",
                    viewBox: "0 0 211 193",
                    fill: "none",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M206.808 192.429L198.297 166.772C198.297 166.772 207.659 176.124 207.659 183.797L205.978 166.053C205.978 166.053 210.779 172.527 210.299 182.358C209.819 192.189 206.808 192.429 206.808 192.429Z",
                      fill: "#F1EDF5",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M24.0293 169.068L15.7227 144.028C15.7227 144.028 24.8594 153.154 24.8594 160.643L23.2195 143.326C23.2195 143.326 27.905 149.644 27.4364 159.239C26.9679 168.834 24.0293 169.068 24.0293 169.068Z",
                      fill: "#F1EDF5",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M153.682 180.622C153.697 197.094 120.991 192.027 80.9519 192.062C40.9126 192.097 8.70174 197.219 8.6875 180.747C8.67327 164.276 41.3669 160.665 81.4061 160.631C121.445 160.596 153.668 164.151 153.682 180.622Z",
                      fill: "#F1EDF5",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M125.62 158.377H120.386L117.895 138.209H125.62V158.377Z",
                      fill: "#A0616A",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M116.064 156.883H126.741V163.233H110.289V162.652C110.289 161.122 110.897 159.655 111.98 158.573C113.063 157.491 114.532 156.883 116.064 156.883Z",
                      fill: "#2F2E41",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M164.097 188.145H158.862L156.371 167.976H164.097V188.145Z",
                      fill: "#A0616A",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M154.54 186.651H165.217V193H148.766V192.419C148.766 190.889 149.374 189.422 150.457 188.34C151.54 187.258 153.009 186.651 154.54 186.651Z",
                      fill: "#2F2E41",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M188.242 128.228C188.604 127.79 188.866 127.278 189.008 126.727C189.15 126.177 189.17 125.603 189.066 125.044C188.961 124.485 188.736 123.956 188.405 123.494C188.074 123.032 187.646 122.648 187.15 122.369L174.992 72.8977L167.219 76.2386L181.679 124.073C181.266 124.936 181.183 125.92 181.447 126.84C181.711 127.759 182.304 128.55 183.113 129.063C183.922 129.575 184.891 129.773 185.836 129.619C186.782 129.465 187.638 128.971 188.242 128.228Z",
                      fill: "#A0616A",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M178.758 28.2463C178.324 27.7932 177.796 27.4406 177.211 27.2135C176.626 26.9863 175.998 26.89 175.372 26.9314C174.745 26.9728 174.136 27.1509 173.586 27.4531C173.036 27.7553 172.559 28.1743 172.189 28.6805L153.371 30.8385L156.234 38.0886L173.347 34.8893C174.24 35.4544 175.309 35.6727 176.352 35.503C177.395 35.3333 178.339 34.7873 179.006 33.9685C179.673 33.1496 180.016 32.1148 179.971 31.0602C179.925 30.0056 179.493 29.0043 178.758 28.2463Z",
                      fill: "#A0616A",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M147.75 123.098L155.961 184.657L166.181 182.556C166.181 182.556 164.678 137.723 169.788 132.319C174.898 126.914 163.216 117.446 163.216 117.446L147.75 123.098Z",
                      fill: "#2F2E41",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M151.146 106.142L147.374 111.794C147.374 111.794 118.328 99.7367 118.328 118.953C118.328 138.17 116.666 151.211 116.065 152.112C115.464 153.012 123.02 155.35 126.627 154.749C126.627 154.749 131.077 123.769 130.777 121.968C130.777 121.968 159.269 135.922 164.68 134.721C170.09 133.52 171.368 129.268 172.27 126.866C173.172 124.464 171.893 105.388 171.893 105.388L153.858 99.8907L151.146 106.142Z",
                      fill: "#2F2E41",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M151.652 72.2072L150.577 70.9184C150.577 70.9184 138.535 43.8535 143.265 36.5503C147.996 29.2471 168.64 28.1731 169.285 28.6027C169.93 29.0323 167.744 34.61 169.249 37.1876C169.249 37.1876 153.258 40.6508 152.182 41.0804C151.107 41.51 160.468 57.386 160.468 57.386L159.393 67.052L151.652 72.2072Z",
                      fill: "#B64985",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M172.727 58.8895C172.727 58.8895 161.545 60.1783 161.115 60.1783C160.685 60.1783 160.47 57.3859 160.47 57.3859L150.578 70.9183C150.578 70.9183 145.705 110.178 146.995 109.533C148.285 108.889 172.082 112.59 172.297 110.871C172.512 109.153 172.082 100.561 172.727 100.131C173.372 99.7016 183.909 73.0663 183.909 73.0663C183.909 73.0663 182.833 67.4815 179.178 65.5483C175.522 63.6151 172.727 58.8895 172.727 58.8895Z",
                      fill: "#B64985",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M180.468 69.4148L183.909 73.0664C183.909 73.0664 189.021 115.027 186.225 116.316C183.43 117.604 177.926 117.446 177.926 117.446L172.512 97.5536L180.468 69.4148Z",
                      fill: "#B64985",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M161.98 56.2323C167.446 56.2323 171.877 51.8058 171.877 46.3455C171.877 40.8852 167.446 36.4587 161.98 36.4587C156.513 36.4587 152.082 40.8852 152.082 46.3455C152.082 51.8058 156.513 56.2323 161.98 56.2323Z",
                      fill: "#A0616A",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M159.66 47.8882C159.526 45.8367 156.935 45.7664 154.877 45.747C152.819 45.7276 150.358 45.801 149.194 44.1059C148.424 42.9857 148.571 41.4305 149.207 40.2295C149.843 39.0284 150.889 38.1047 151.918 37.216C154.574 34.9218 157.311 32.6457 160.5 31.1772C163.689 29.7087 167.426 29.1154 170.733 30.2942C174.796 31.7422 180.288 39.1964 180.762 43.4791C181.236 47.7617 179.523 52.1276 176.634 55.3279C173.746 58.5282 167.135 57.2369 162.975 58.3754C165.504 54.7997 163.837 48.3026 159.786 46.6328L159.66 47.8882Z",
                      fill: "#2F2E41",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M71.448 175.775C84.5706 175.775 95.2085 165.149 95.2085 152.041C95.2085 138.932 84.5706 128.306 71.448 128.306C58.3255 128.306 47.6875 138.932 47.6875 152.041C47.6875 165.149 58.3255 175.775 71.448 175.775Z",
                      fill: "#AB6E93",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M55.5789 126.62C52.2859 126.62 49.0634 125.667 46.3014 123.875C43.5395 122.084 41.3565 119.532 40.0168 116.527L2.3133 31.7121C1.06436 28.9026 0.403815 25.8677 0.372279 22.7938C0.340743 19.7199 0.938878 16.6721 2.12992 13.8376C3.32096 11.0032 5.07975 8.44194 7.29816 6.31142C9.51658 4.1809 12.1478 2.52609 15.03 1.44869C17.9122 0.371286 20.9845 -0.105935 24.0582 0.0463625C27.1318 0.19866 30.1418 0.977254 32.9031 2.33429C35.6644 3.69132 38.1187 5.59813 40.1152 7.93749C42.1116 10.2769 43.608 12.9994 44.5124 15.9377L71.8143 104.641C72.5959 107.18 72.7705 109.867 72.3241 112.485C71.8777 115.104 70.8226 117.581 69.2437 119.719C67.6649 121.856 65.6061 123.594 63.2329 124.793C60.8597 125.991 58.2382 126.617 55.5789 126.62Z",
                      fill: "#AB6E93",
                    },
                  }),
                ]
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "container-switch" },
            [
              _c("ComponentSwitch", {
                attrs: {
                  value:
                    _vm.notifications.error == true ||
                    _vm.notifications.error == "true",
                  size: "xxl",
                  onChange: _vm.handleChangeStateNotification,
                  id: "error",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _c("div", { staticClass: "card card-validation" }, [
        _c("header", [
          _c("i", { staticClass: "fa-solid fa-bell" }),
          _vm._v(
            "\n                    " +
              _vm._s(_vm.$t("dash.settings.notifications.validation.title")) +
              "\n                "
          ),
        ]),
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "container-info" }, [
            _c("div", { staticClass: "notification-info" }, [
              _c("h4", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "dash.settings.notifications.validation.content.title"
                    )
                  )
                ),
              ]),
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "dash.settings.notifications.validation.content.subtitle"
                    )
                  ) + "."
                ),
              ]),
            ]),
            _c("div", { staticClass: "svg" }, [
              _c(
                "svg",
                {
                  attrs: {
                    width: "100%",
                    height: "100%",
                    viewBox: "0 0 308 200",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M306.2 180.506C304.638 181.055 302.962 181.192 301.331 180.905C299.701 180.618 298.172 179.916 296.891 178.867C293.631 176.132 292.608 171.627 291.777 167.454L289.316 155.112L294.467 158.657C298.172 161.206 301.959 163.837 304.524 167.53C307.088 171.222 308.207 176.263 306.147 180.258",
                      fill: "#F1EDF5",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M305.406 196.308C306.054 191.587 306.721 186.805 306.266 182.034C305.862 177.796 304.568 173.658 301.935 170.264C300.537 168.466 298.836 166.925 296.909 165.711C296.406 165.394 295.943 166.19 296.444 166.506C299.779 168.612 302.359 171.723 303.811 175.39C305.415 179.467 305.672 183.911 305.396 188.243C305.229 190.862 304.874 193.464 304.518 196.063C304.49 196.18 304.507 196.304 304.567 196.409C304.627 196.514 304.724 196.593 304.839 196.629C304.957 196.66 305.083 196.644 305.189 196.584C305.295 196.524 305.373 196.424 305.406 196.307L305.406 196.308Z",
                      fill: "#E3D2EE",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M300.74 188.733C300.07 189.751 299.149 190.579 298.066 191.138C296.983 191.697 295.774 191.967 294.556 191.924C291.425 191.775 288.816 189.592 286.468 187.518L279.52 181.387L284.118 181.167C287.425 181.009 290.817 180.86 293.967 181.881C297.116 182.901 300.021 185.353 300.597 188.612",
                      fill: "#F1EDF5",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M307.237 199.021C304.116 193.502 300.496 187.367 294.027 185.406C292.229 184.863 290.343 184.669 288.471 184.833C287.881 184.884 288.029 185.793 288.618 185.742C291.755 185.482 294.886 186.31 297.484 188.087C299.985 189.788 301.931 192.152 303.579 194.66C304.588 196.196 305.492 197.797 306.396 199.396C306.685 199.907 307.53 199.538 307.237 199.021Z",
                      fill: "#E3D2EE",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M195.758 58.8866V111.444H74.3077V139.349H42.1992V58.8866H195.758Z",
                      fill: "white",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M40.8027 57.4938V140.746H74.3087V137.957H43.5936V60.2832H194.366V111.443H197.157V57.4938H40.8027Z",
                      fill: "#F1EDF5",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M171.726 88.6698H74.3867V92.1042H171.726V88.6698Z",
                      fill: "#F1EDF5",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M171.726 97.5991H74.3867V101.033H171.726V97.5991Z",
                      fill: "#F1EDF5",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M171.726 106.528H74.3867V109.963H171.726V106.528Z",
                      fill: "#F1EDF5",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M68.4769 92.7579C69.7153 92.7579 70.7193 91.7545 70.7193 90.5166C70.7193 89.2787 69.7153 88.2753 68.4769 88.2753C67.2384 88.2753 66.2344 89.2787 66.2344 90.5166C66.2344 91.7545 67.2384 92.7579 68.4769 92.7579Z",
                      fill: "#F1EDF5",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M153.956 0.3927V52.9496H32.5049V80.8556H0.396484V0.3927H153.956Z",
                      fill: "white",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M236.078 118.142H82.5156V198.605H236.078V118.142Z",
                      fill: "white",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M237.475 200H81.1211V116.747H237.475V200ZM83.9131 197.209H234.683V119.537H83.9131V197.209Z",
                      fill: "#AB6E93",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M211.874 148.051H114.535V151.485H211.874V148.051Z",
                      fill: "#AB6E93",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M211.874 156.98H114.535V160.414H211.874V156.98Z",
                      fill: "#AB6E93",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M211.874 165.909H114.535V169.344H211.874V165.909Z",
                      fill: "#AB6E93",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M108.627 152.139C109.866 152.139 110.87 151.135 110.87 149.897C110.87 148.659 109.866 147.656 108.627 147.656C107.389 147.656 106.385 148.659 106.385 149.897C106.385 151.135 107.389 152.139 108.627 152.139Z",
                      fill: "#AB6E93",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M213.444 116.75C213.105 116.272 212.875 115.726 212.77 115.15C212.665 114.573 212.688 113.981 212.837 113.415C212.985 112.848 213.257 112.321 213.631 111.871C214.006 111.421 214.475 111.058 215.005 110.809L226.111 76.0518L233.846 80.0677L220.497 112.97C220.857 113.888 220.868 114.906 220.528 115.831C220.188 116.757 219.519 117.525 218.65 117.991C217.781 118.457 216.77 118.588 215.811 118.359C214.851 118.13 214.009 117.558 213.444 116.75Z",
                      fill: "#9F616A",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M222.517 80.8581C222.41 80.6229 222.356 80.3675 222.357 80.1094C222.359 79.8513 222.416 79.5965 222.525 79.3625L226.329 71.1883C226.704 69.9219 227.566 68.8559 228.727 68.224C229.887 67.592 231.25 67.4458 232.518 67.8172C233.786 68.1887 234.855 69.0476 235.491 70.2056C236.126 71.3635 236.276 72.7261 235.908 73.9944L234.637 82.9491C234.6 83.2047 234.509 83.4494 234.37 83.6667C234.23 83.8839 234.046 84.0685 233.828 84.208C233.611 84.3475 233.366 84.4385 233.111 84.4749C232.855 84.5113 232.594 84.4922 232.347 84.4189L223.644 81.8417C223.397 81.7685 223.168 81.6427 222.973 81.473C222.778 81.3032 222.623 81.0935 222.517 80.8581Z",
                      fill: "#B64985",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M254.601 82.2375L253.981 90.9193L232.886 98.3608L232.576 89.989L254.601 82.2375Z",
                      fill: "#9F616A",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M227.612 69.5253L234.437 64.5644L245.604 61.4638L254.911 63.3241L256.462 77.8968L254.601 87.1985L230.404 92.7795L227.922 88.4387C227.922 88.4387 222.338 82.8577 226.681 76.6566L227.612 69.5253Z",
                      fill: "#B64985",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M225.131 56.7922V48.6496C225.131 45.2046 226.5 41.9007 228.937 39.4647C231.375 37.0287 234.68 35.6602 238.127 35.6602C241.574 35.6602 244.879 37.0287 247.317 39.4647C249.754 41.9007 251.123 45.2046 251.123 48.6496V56.7922C251.122 57.2548 250.938 57.6983 250.611 58.0254C250.284 58.3526 249.84 58.5366 249.377 58.5371H226.877C226.414 58.5366 225.97 58.3526 225.643 58.0254C225.315 57.6983 225.131 57.2548 225.131 56.7922Z",
                      fill: "#2F2E41",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M237.604 58.4569C242.867 58.4569 247.133 54.1931 247.133 48.9335C247.133 43.6739 242.867 39.4101 237.604 39.4101C232.342 39.4101 228.076 43.6739 228.076 48.9335C228.076 54.1931 232.342 58.4569 237.604 58.4569Z",
                      fill: "#9F616A",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M227.815 48.8968C227.724 48.7918 227.657 48.6684 227.617 48.5351C227.578 48.4018 227.568 48.2616 227.588 48.124L228.717 40.2684C228.739 40.1086 228.801 39.9568 228.897 39.8269C228.993 39.697 229.119 39.593 229.265 39.5243C235.027 36.8294 240.869 36.826 246.63 39.5141C246.783 39.5865 246.914 39.6973 247.011 39.8357C247.108 39.9741 247.168 40.1353 247.184 40.3036L247.937 48.1695C247.95 48.3039 247.935 48.4396 247.892 48.5678C247.85 48.696 247.781 48.8139 247.69 48.9139C247.599 49.0138 247.488 49.0937 247.364 49.1484C247.241 49.203 247.107 49.2312 246.972 49.2312H245.061C244.877 49.2307 244.696 49.178 244.541 49.0789C244.385 48.9799 244.261 48.8388 244.182 48.6719L243.358 46.9059C243.304 46.7915 243.215 46.6976 243.104 46.6383C242.992 46.579 242.865 46.5576 242.74 46.5772C242.615 46.5968 242.5 46.6564 242.412 46.7471C242.324 46.8377 242.269 46.9545 242.253 47.0797L242.09 48.3819C242.06 48.6162 241.946 48.8318 241.769 48.9881C241.592 49.1445 241.364 49.2309 241.128 49.2312H228.548C228.409 49.2312 228.272 49.2014 228.145 49.1437C228.019 49.086 227.906 49.0018 227.815 48.8968Z",
                      fill: "#2F2E41",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M269.178 112.694C268.607 112.562 268.072 112.306 267.611 111.945C267.15 111.583 266.774 111.125 266.509 110.603C266.244 110.08 266.097 109.506 266.079 108.921C266.06 108.336 266.17 107.753 266.4 107.215L251.625 73.8507L260.077 71.7229L271.943 105.188C272.822 105.635 273.507 106.389 273.867 107.307C274.227 108.225 274.237 109.244 273.896 110.169C273.556 111.094 272.887 111.862 272.017 112.328C271.148 112.793 270.137 112.924 269.178 112.694Z",
                      fill: "#9F616A",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M252.127 79.8301C251.892 79.7247 251.682 79.5697 251.511 79.3756C251.341 79.1816 251.214 78.9531 251.141 78.7058L248.557 70.0683C247.997 68.8723 247.934 67.503 248.382 66.2605C248.83 65.0181 249.753 64.004 250.948 63.4406C252.143 62.8772 253.513 62.8105 254.757 63.2551C256.001 63.6997 257.018 64.6193 257.585 65.8123L262.581 73.3533C262.724 73.5686 262.818 73.812 262.858 74.067C262.898 74.322 262.883 74.5826 262.813 74.8311C262.743 75.0796 262.62 75.3101 262.453 75.5069C262.286 75.7038 262.078 75.8623 261.845 75.9717L253.624 79.8177C253.39 79.9272 253.135 79.9851 252.877 79.9872C252.619 79.9893 252.363 79.9357 252.127 79.8301Z",
                      fill: "#B64985",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M253.54 194.121L248.162 194.121L245.604 173.388L253.54 173.389L253.54 194.121Z",
                      fill: "#9F616A",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M254.911 199.331L237.57 199.331V199.112C237.57 197.323 238.282 195.607 239.547 194.342C240.813 193.077 242.53 192.366 244.32 192.366H244.32L254.911 192.366L254.911 199.331Z",
                      fill: "#2F2E41",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M249.454 150.347L245.787 154.28L228.867 142.017L234.278 136.213L249.454 150.347Z",
                      fill: "#9F616A",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M254.202 152.896L242.381 165.576L242.22 165.426C240.911 164.207 240.14 162.517 240.076 160.729C240.013 158.941 240.663 157.201 241.884 155.892L241.884 155.892L249.104 148.148L254.202 152.896Z",
                      fill: "#2F2E41",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M255.221 90.9192L256.941 92.6383C265.545 101.237 267.663 113.16 266.629 125.277C266.485 127.073 266.197 128.856 265.769 130.606C262.667 143.009 264.528 182.696 258.324 185.176L257.083 189.517L244.984 189.07L245.294 185.176C245.294 185.176 242.503 179.285 244.364 175.565C246.225 171.844 250.258 144.249 250.258 144.249L248.086 121.615L231.955 129.676C231.955 129.676 240.331 134.327 239.711 137.428C239.711 137.428 244.674 138.668 243.433 141.769L245.294 145.489L240.951 152.31C240.951 152.31 211.791 134.947 214.273 126.266C216.755 117.584 232.265 111.383 232.265 111.383L233.506 102.081L232.436 97.0129L254.141 88.674L255.221 90.9192Z",
                      fill: "#2F2E41",
                    },
                  }),
                ]
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "container-switch" },
            [
              _c("ComponentSwitch", {
                attrs: {
                  value:
                    _vm.notifications.info == true ||
                    _vm.notifications.info == "true",
                  size: "xxl",
                  onChange: _vm.handleChangeStateNotification,
                  id: "info",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm.activeInbox()
        ? _c("div", { staticClass: "card card-inbox" }, [
            _c("header", [
              _c("i", { staticClass: "fa-solid fa-bell" }),
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$t("dash.settings.notifications.inbox.title")) +
                  "\n                "
              ),
            ]),
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "container-info" }, [
                _c("div", { staticClass: "notification-info" }, [
                  _c("h4", {}, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "dash.settings.notifications.inbox.content.title"
                        )
                      )
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "dash.settings.notifications.inbox.content.subtitle"
                        )
                      )
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "svg" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "100%",
                        height: "100%",
                        viewBox: "0 0 208 177",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c(
                        "g",
                        { attrs: { "clip-path": "url(#clip0_1576_50)" } },
                        [
                          _c("path", {
                            attrs: {
                              d: "M146.873 175.153C143.534 172.348 141.506 167.918 142.038 163.604C142.569 159.291 145.864 155.326 150.137 154.41C154.41 153.494 159.282 156.029 160.579 160.179C161.294 152.179 162.117 143.843 166.396 137.03C170.27 130.861 176.981 126.447 184.253 125.657C191.526 124.867 199.183 127.85 203.719 133.556C208.254 139.262 209.365 147.558 206.188 154.109C203.848 158.935 199.537 162.527 195.019 165.449C180.423 174.811 162.916 178.619 145.72 176.17",
                              fill: "#F1EDF5",
                            },
                          }),
                          _c("path", {
                            attrs: {
                              d: "M196.527 128.015C190.527 132.874 185.021 138.308 180.092 144.239C172.376 153.49 166.133 163.861 161.58 174.992C161.246 175.804 162.573 176.157 162.902 175.354C165.798 168.317 169.381 161.578 173.599 155.235C180.177 145.327 188.235 136.474 197.497 128.98C198.182 128.425 197.206 127.466 196.527 128.015Z",
                              fill: "white",
                            },
                          }),
                          _c("path", {
                            attrs: {
                              d: "M144.567 175.153C147.906 172.348 149.934 167.918 149.402 163.604C148.87 159.291 145.576 155.326 141.302 154.41C137.029 153.494 132.158 156.029 130.86 160.179C130.146 152.179 129.323 143.843 125.044 137.03C121.169 130.861 114.459 126.447 107.186 125.657C99.9137 124.867 92.2566 127.85 87.7209 133.556C83.1852 139.262 82.0747 147.558 85.2513 154.109C87.5915 158.935 91.9028 162.527 96.4201 165.449C111.017 174.811 128.524 178.619 145.72 176.17",
                              fill: "#F1EDF5",
                            },
                          }),
                          _c("path", {
                            attrs: {
                              d: "M94.9131 128.015C100.914 132.874 106.419 138.308 111.349 144.239C119.064 153.49 125.307 163.861 129.861 174.992C130.194 175.804 128.868 176.157 128.538 175.354C121.087 157.264 109.193 141.32 93.9431 128.98C93.2583 128.425 94.2339 127.466 94.9131 128.015Z",
                              fill: "white",
                            },
                          }),
                          _c("path", {
                            attrs: {
                              d: "M134.659 79.6231C128.482 79.6231 123.474 74.6451 123.474 68.5045C123.474 62.3639 128.482 57.386 134.659 57.386C140.836 57.386 145.844 62.3639 145.844 68.5045C145.844 74.6451 140.836 79.6231 134.659 79.6231Z",
                              fill: "#F2F2F2",
                            },
                          }),
                          _c("path", {
                            attrs: {
                              d: "M169.143 30.177H92.0831V34.3681H159.306C163.258 34.3681 167.172 35.1419 170.823 36.6455C174.475 38.1491 177.793 40.3529 180.588 43.1312C183.382 45.9094 185.599 49.2076 187.112 52.8376C188.624 56.4676 189.403 60.3581 189.403 64.2871V111.903H197.835C198.208 111.903 198.565 111.755 198.829 111.494C199.092 111.232 199.24 110.876 199.24 110.506V60.0961C199.24 56.167 198.462 52.2765 196.949 48.6465C195.437 45.0166 193.22 41.7183 190.425 38.9401C187.63 36.1618 184.312 33.958 180.661 32.4544C177.009 30.9509 173.095 30.177 169.143 30.177Z",
                              fill: "#F1EDF5",
                            },
                          }),
                          _c("path", {
                            attrs: {
                              d: "M154.322 175.386V111.723H135.561V175.386C135.561 175.814 135.732 176.224 136.037 176.527C136.341 176.829 136.754 177 137.184 177H152.699C153.129 177 153.542 176.829 153.846 176.527C154.151 176.224 154.322 175.814 154.322 175.386Z",
                              fill: "#2F2E41",
                            },
                          }),
                          _c("path", {
                            attrs: {
                              d: "M203.209 110.468V58.7008C203.2 50.4597 199.902 42.5589 194.04 36.7316C188.178 30.9043 180.23 27.6264 171.94 27.6171H92.4439V112.261H201.405C201.883 112.261 202.342 112.072 202.68 111.736C203.018 111.399 203.208 110.944 203.209 110.468ZM93.1655 28.3344H171.94C180.039 28.3435 187.804 31.5458 193.53 37.2386C199.257 42.9314 202.478 50.6499 202.487 58.7008V110.468C202.487 110.753 202.373 111.027 202.17 111.229C201.967 111.43 201.692 111.544 201.405 111.544H93.1655V28.3344Z",
                              fill: "#3F3D56",
                            },
                          }),
                          _c("path", {
                            attrs: {
                              d: "M134.658 74.2432C136.38 74.2412 138.031 73.5604 139.248 72.3501C140.466 71.1398 141.151 69.4989 141.153 67.7872V21.5198C141.153 21.2345 141.267 20.961 141.47 20.7593C141.673 20.5575 141.948 20.4441 142.235 20.4438H167.491C167.969 20.4432 168.428 20.2541 168.766 19.9179C169.104 19.5817 169.294 19.1259 169.295 18.6505V1.79331C169.294 1.31787 169.104 0.862048 168.766 0.525855C168.428 0.189663 167.969 0.000550561 167.491 0H129.968C129.49 0.00054393 129.031 0.189656 128.693 0.52585C128.355 0.862044 128.164 1.31786 128.164 1.79331V67.7872C128.166 69.4989 128.851 71.1398 130.068 72.3501C131.286 73.5604 132.936 74.2412 134.658 74.2432Z",
                              fill: "#B64985",
                            },
                          }),
                          _c("path", {
                            attrs: {
                              d: "M89.5575 26.8997C84.1146 26.8884 78.8902 29.0269 75.0334 32.8448C71.1766 36.6627 69.0035 41.8472 68.992 47.2579V106.19H28.5826C26.9593 106.186 25.4011 106.824 24.2509 107.963C23.1006 109.101 22.4525 110.648 22.449 112.261H110.123V47.2579C110.112 41.8472 107.939 36.6627 104.082 32.8448C100.225 29.0269 95.0004 26.8884 89.5575 26.8997Z",
                              fill: "#2F2E41",
                            },
                          }),
                          _c("path", {
                            attrs: {
                              d: "M94.4941 60.4589L90.2357 77.9459L6.9341 57.8997L11.1925 40.4127C11.244 40.1989 11.3489 40.0015 11.4977 39.8387C11.6464 39.676 11.834 39.5533 12.0432 39.4819C12.1976 39.4279 12.3609 39.4035 12.5245 39.4099L60.6764 14.6257C60.9586 14.4824 61.2829 14.4442 61.591 14.5178C61.899 14.5914 62.1705 14.772 62.3564 15.0271L85.5629 47.1969L94.3115 59.3279C94.3273 59.3491 94.3384 59.3735 94.344 59.3994C94.3495 59.4253 94.3494 59.452 94.3436 59.4779C94.5216 59.7725 94.5757 60.1249 94.4941 60.4589Z",
                              fill: "white",
                            },
                          }),
                          _c("path", {
                            attrs: {
                              d: "M94.3432 59.4779C94.3391 59.5006 94.3305 59.5223 94.3179 59.5418C94.3053 59.5612 94.289 59.578 94.2699 59.5912C94.2473 59.6065 94.2218 59.6172 94.1949 59.6225C94.168 59.6277 94.1404 59.6275 94.1136 59.6218C94.07 59.6103 94.0319 59.584 94.0057 59.5475L93.9757 59.5061L93.5202 58.8729L85.2475 47.4085L62.0478 15.2461C61.9154 15.0638 61.7217 14.9348 61.5018 14.8824C61.2819 14.83 61.0504 14.8577 60.8493 14.9605L13.0704 39.5528L12.6417 39.774C12.6243 39.7812 12.6066 39.7874 12.5885 39.7925C12.5562 39.7867 12.5234 39.7836 12.4905 39.7832C12.4457 39.7683 12.4083 39.7369 12.386 39.6954C12.3744 39.6736 12.3672 39.6497 12.3648 39.6251C12.3625 39.6005 12.3651 39.5757 12.3724 39.5521C12.3798 39.5284 12.3917 39.5065 12.4076 39.4875C12.4235 39.4685 12.4429 39.4528 12.4649 39.4412L12.5241 39.4099L60.676 14.6257C60.9582 14.4824 61.2825 14.4442 61.5906 14.5178C61.8987 14.5914 62.1701 14.772 62.356 15.0271L85.5625 47.1969L94.3111 59.3279C94.327 59.3491 94.3381 59.3735 94.3436 59.3994C94.3491 59.4253 94.349 59.452 94.3432 59.4779Z",
                              fill: "#3F3D56",
                            },
                          }),
                          _c("path", {
                            attrs: {
                              d: "M69.325 61.2609L67.4707 61.4654L53.709 62.9809L44.5859 63.9849L44.047 64.0445L32.663 55.2053L32.2269 54.8667L29.5381 52.7792L19.972 45.3527L19.9146 44.831L16.5121 14.3038C16.4657 13.8834 16.5889 13.4619 16.8547 13.1317C17.1204 12.8015 17.507 12.5895 17.9298 12.5422L63.3383 7.5418C63.7612 7.4959 64.1851 7.61843 64.5172 7.88256C64.8493 8.1467 65.0627 8.53091 65.1104 8.95106L67.5099 30.4843L68.8409 42.4227L70.0315 53.1031L70.5834 58.0631L70.7445 59.4998C70.7904 59.9203 70.6668 60.3418 70.4008 60.6719C70.1347 61.002 69.7478 61.2138 69.325 61.2609Z",
                              fill: "#F1EDF5",
                            },
                          }),
                          _c("path", {
                            attrs: {
                              d: "M56.8463 34.5025L37.1767 36.6682L30.2012 37.4359C29.8932 37.4699 29.5816 37.4431 29.284 37.3573C28.9864 37.2715 28.7087 37.1282 28.4669 36.9357C28.225 36.7432 28.0236 36.5052 27.8742 36.2354C27.7248 35.9655 27.6304 35.669 27.5963 35.3629C27.5622 35.0567 27.5891 34.7469 27.6754 34.4511C27.7618 34.1552 27.9059 33.8792 28.0995 33.6388C28.2932 33.3983 28.5326 33.1981 28.804 33.0496C29.0755 32.9012 29.3738 32.8073 29.6817 32.7734L38.3578 31.8182L56.3253 29.8377C56.9474 29.7694 57.5714 29.9494 58.06 30.3383C58.5486 30.7271 58.8618 31.2929 58.9309 31.9113C58.9999 32.5297 58.8191 33.1501 58.4282 33.636C58.0373 34.1219 57.4683 34.4336 56.8463 34.5025Z",
                              fill: "white",
                            },
                          }),
                          _c("path", {
                            attrs: {
                              d: "M57.9658 43.1521C57.915 43.1611 57.8642 43.1701 57.8126 43.1751L34.9794 45.6896L31.1671 46.1103C30.5449 46.1787 29.9208 45.9986 29.4321 45.6096C28.9435 45.2206 28.6303 44.6546 28.5615 44.0361C28.4927 43.4175 28.6738 42.7971 29.0651 42.3114C29.4564 41.8256 30.0258 41.5143 30.6481 41.4459L36.1605 40.8396L54.2474 38.8473L57.2912 38.512C57.8999 38.4445 58.5112 38.615 58.9958 38.9874C59.4803 39.3597 59.8002 39.9049 59.8878 40.5075C59.9754 41.1101 59.8239 41.7229 59.4652 42.2164C59.1065 42.71 58.5688 43.0455 57.9658 43.1521Z",
                              fill: "white",
                            },
                          }),
                          _c("path", {
                            attrs: {
                              d: "M60.5513 50.8216C60.3642 51.1304 60.108 51.3922 59.8026 51.5866C59.4972 51.781 59.1508 51.9028 58.7904 51.9425L49.4317 52.9729L32.7639 54.8085L32.7602 54.8077L32.2273 54.8667L29.5385 52.7792C29.5219 52.6206 29.5217 52.4608 29.5381 52.3022C29.5948 51.7697 29.8326 51.2724 30.2123 50.8926C30.5919 50.5128 31.0907 50.2731 31.6259 50.2134L33.9413 49.9577L43.1261 48.9473L49.7349 48.2186L58.2714 47.2782C58.7089 47.23 59.1512 47.3045 59.5484 47.4931C59.9455 47.6818 60.2817 47.9771 60.5188 48.3457C60.756 48.7143 60.8847 49.1415 60.8904 49.579C60.8962 50.0166 60.7787 50.447 60.5513 50.8216Z",
                              fill: "white",
                            },
                          }),
                          _c("path", {
                            attrs: {
                              d: "M47.4047 23.9298L42.5107 24.4687L40.3491 24.7073L37.0838 25.0665C36.4616 25.135 35.8375 24.9549 35.3489 24.5659C34.8602 24.1769 34.5471 23.6108 34.4782 22.9923C34.4094 22.3738 34.5906 21.7534 34.9819 21.2676C35.3732 20.7819 35.9426 20.4705 36.5648 20.4021L46.8834 19.2668C47.5054 19.1981 48.1294 19.3778 48.6182 19.7664C49.1069 20.1551 49.4203 20.7208 49.4895 21.3392C49.5586 21.9575 49.3778 22.5779 48.9868 23.0637C48.5959 23.5495 48.0268 23.8611 47.4047 23.9298Z",
                              fill: "white",
                            },
                          }),
                          _c("path", {
                            attrs: {
                              d: "M87.4239 36.9178L81.4573 61.4195L71.4988 63.3018L62.2869 65.0452L52.4033 66.9147L49.2453 67.5121C49.0604 67.5469 48.8702 67.5421 48.6873 67.4981C48.5045 67.454 48.3331 67.3718 48.1847 67.2569L45.6511 65.2898L44.047 64.0445L32.663 55.2054L39.9014 25.4817C39.9729 25.186 40.1287 24.9171 40.3503 24.7073C40.5446 24.5217 40.7827 24.3877 41.0428 24.3177C41.3029 24.2477 41.5766 24.2439 41.8385 24.3066L86.2418 34.9921C86.6553 35.0919 87.0121 35.3508 87.2337 35.7118C87.4554 36.0729 87.5238 36.5067 87.4239 36.9178Z",
                              fill: "#AB6E93",
                            },
                          }),
                          _c("path", {
                            attrs: {
                              d: "M73.7428 56.4097C73.595 57.0141 73.2121 57.5355 72.678 57.8595C72.1438 58.1834 71.5022 58.2835 70.894 58.1377L44.8391 51.8677C44.2313 51.7205 43.707 51.3398 43.3811 50.8089C43.0553 50.278 42.9545 49.6404 43.1008 49.0358C43.1075 49.0058 43.116 48.9762 43.1262 48.9473C43.2926 48.3643 43.6795 47.868 44.2058 47.5624C44.7322 47.2568 45.3571 47.1655 45.9496 47.3077L72.0044 53.5777C72.6124 53.7246 73.137 54.1053 73.4629 54.6362C73.7888 55.1672 73.8895 55.805 73.7428 56.4097Z",
                              fill: "white",
                            },
                          }),
                          _c("path", {
                            attrs: {
                              d: "M71.498 63.3018L62.2861 65.0452L42.7725 60.3493C42.1642 60.203 41.6394 59.8224 41.3134 59.2913C40.9874 58.7602 40.8869 58.1221 41.0342 57.5174C41.1814 56.9127 41.5643 56.391 42.0985 56.0669C42.6328 55.7428 43.2747 55.643 43.883 55.7894L69.9378 62.0594C70.4823 62.1894 70.9619 62.5089 71.2899 62.9602C71.3688 63.068 71.4385 63.1823 71.498 63.3018Z",
                              fill: "white",
                            },
                          }),
                          _c("path", {
                            attrs: {
                              d: "M52.4023 66.9147L49.2443 67.5121C49.0594 67.5468 48.8692 67.542 48.6863 67.498C48.5035 67.454 48.3321 67.3718 48.1837 67.2569L45.6501 65.2898L52.4023 66.9147Z",
                              fill: "white",
                            },
                          }),
                          _c("path", {
                            attrs: {
                              d: "M68.4924 43.2714C68.3447 43.8758 67.9617 44.3972 67.4276 44.7212C66.8935 45.0452 66.2519 45.1453 65.6436 44.9994L55.552 42.5709C54.9441 42.4238 54.4198 42.043 54.094 41.5121C53.7681 40.9813 53.6673 40.3436 53.8136 39.739C53.8922 39.4141 54.0405 39.1099 54.2484 38.8473C54.5276 38.4923 54.9036 38.2246 55.3317 38.0763C55.7598 37.928 56.2217 37.9053 56.6624 38.011L66.7541 40.4395C67.3623 40.5859 67.8871 40.9666 68.2131 41.4976C68.5391 42.0287 68.6396 42.6667 68.4924 43.2714Z",
                              fill: "white",
                            },
                          }),
                          _c("path", {
                            attrs: {
                              d: "M62.2881 65.045L52.403 66.9149L49.2458 67.5126C49.061 67.5469 48.871 67.5419 48.6883 67.4979C48.5056 67.454 48.3343 67.372 48.1858 67.2575L45.6504 65.2899L46.5401 65.504L48.4183 66.9605C48.5244 67.0423 48.6468 67.1009 48.7773 67.1323C48.9078 67.1637 49.0435 67.1673 49.1756 67.1428L51.5133 66.7008L61.3984 64.8308L62.2881 65.045ZM32.7612 54.8091L32.665 55.2043L32.2265 54.8654L32.7612 54.8091ZM62.2881 65.045L52.403 66.9149L49.2458 67.5126C49.061 67.5469 48.871 67.5419 48.6883 67.4979C48.5056 67.454 48.3343 67.372 48.1858 67.2575L45.6504 65.2899L46.5401 65.504L48.4183 66.9605C48.5244 67.0423 48.6468 67.1009 48.7773 67.1323C48.9078 67.1637 49.0435 67.1673 49.1756 67.1428L51.5133 66.7008L61.3984 64.8308L62.2881 65.045ZM62.2881 65.045L52.403 66.9149L49.2458 67.5126C49.061 67.5469 48.871 67.5419 48.6883 67.4979C48.5056 67.454 48.3343 67.372 48.1858 67.2575L45.6504 65.2899L46.5401 65.504L48.4183 66.9605C48.5244 67.0423 48.6468 67.1009 48.7773 67.1323C48.9078 67.1637 49.0435 67.1673 49.1756 67.1428L51.5133 66.7008L61.3984 64.8308L62.2881 65.045ZM94.4941 60.4588L83.3397 106.264C83.2569 106.602 83.0424 106.894 82.7433 107.076C82.4442 107.257 82.0849 107.313 81.7442 107.231L1.01166 87.8035C0.671153 87.7212 0.377394 87.508 0.194866 87.2106C0.0123379 86.9133 -0.0440494 86.5561 0.0380959 86.2174L11.1925 40.4126C11.244 40.1988 11.3489 40.0013 11.4977 39.8386C11.6464 39.6759 11.834 39.5532 12.0432 39.4818C12.1976 39.4278 12.3609 39.4034 12.5245 39.4098C12.7152 39.4153 12.9021 39.4642 13.0708 39.5527C13.1487 39.5894 13.2222 39.6348 13.2899 39.6879L19.9156 44.8311L29.5382 52.3032L32.7619 54.8064L32.7612 54.8091L32.764 54.8097L44.5858 63.9836L46.5401 65.504L48.4183 66.9605C48.5244 67.0423 48.6468 67.1009 48.7773 67.1323C48.9078 67.1637 49.0435 67.1673 49.1756 67.1428L51.5133 66.7008L61.3984 64.8308L71.2923 62.9602L92.9622 58.8608C93.147 58.8244 93.3375 58.8285 93.5206 58.8728C93.767 58.9326 93.9909 59.0616 94.1657 59.2443C94.2327 59.3161 94.2922 59.3943 94.3436 59.4778C94.5216 59.7724 94.5757 60.1248 94.4941 60.4588ZM62.2881 65.045L52.403 66.9149L49.2458 67.5126C49.061 67.5469 48.871 67.5419 48.6883 67.4979C48.5056 67.454 48.3343 67.372 48.1858 67.2575L45.6504 65.2899L46.5401 65.504L48.4183 66.9605C48.5244 67.0423 48.6468 67.1009 48.7773 67.1323C48.9078 67.1637 49.0435 67.1673 49.1756 67.1428L51.5133 66.7008L61.3984 64.8308L62.2881 65.045ZM62.2881 65.045L52.403 66.9149L49.2458 67.5126C49.061 67.5469 48.871 67.5419 48.6883 67.4979C48.5056 67.454 48.3343 67.372 48.1858 67.2575L45.6504 65.2899L46.5401 65.504L48.4183 66.9605C48.5244 67.0423 48.6468 67.1009 48.7773 67.1323C48.9078 67.1637 49.0435 67.1673 49.1756 67.1428L51.5133 66.7008L61.3984 64.8308L62.2881 65.045ZM62.2881 65.045L52.403 66.9149L49.2458 67.5126C49.061 67.5469 48.871 67.5419 48.6883 67.4979C48.5056 67.454 48.3343 67.372 48.1858 67.2575L45.6504 65.2899L46.5401 65.504L48.4183 66.9605C48.5244 67.0423 48.6468 67.1009 48.7773 67.1323C48.9078 67.1637 49.0435 67.1673 49.1756 67.1428L51.5133 66.7008L61.3984 64.8308L62.2881 65.045Z",
                              fill: "white",
                            },
                          }),
                          _c("path", {
                            attrs: {
                              d: "M62.2881 65.0451L52.403 66.915L49.2458 67.5127C49.061 67.547 48.871 67.542 48.6883 67.498C48.5056 67.4541 48.3343 67.3721 48.1858 67.2576L45.6504 65.29L46.5401 65.5041L48.4183 66.9606C48.5244 67.0425 48.6468 67.101 48.7773 67.1324C48.9078 67.1638 49.0435 67.1674 49.1756 67.1429L51.5133 66.7009L61.3984 64.831L62.2881 65.0451ZM32.7612 54.8092L32.665 55.2044L32.2265 54.8655L32.7612 54.8092ZM62.2881 65.0451L52.403 66.915L49.2458 67.5127C49.061 67.547 48.871 67.542 48.6883 67.498C48.5056 67.4541 48.3343 67.3721 48.1858 67.2576L45.6504 65.29L46.5401 65.5041L48.4183 66.9606C48.5244 67.0425 48.6468 67.101 48.7773 67.1324C48.9078 67.1638 49.0435 67.1674 49.1756 67.1429L51.5133 66.7009L61.3984 64.831L62.2881 65.0451ZM62.2881 65.0451L52.403 66.915L49.2458 67.5127C49.061 67.547 48.871 67.542 48.6883 67.498C48.5056 67.4541 48.3343 67.3721 48.1858 67.2576L45.6504 65.29L46.5401 65.5041L48.4183 66.9606C48.5244 67.0425 48.6468 67.101 48.7773 67.1324C48.9078 67.1638 49.0435 67.1674 49.1756 67.1429L51.5133 66.7009L61.3984 64.831L62.2881 65.0451ZM93.9761 59.5061L93.927 59.5427C93.9188 59.5293 93.9045 59.5174 93.8937 59.5034C93.7844 59.3903 93.6485 59.3059 93.4984 59.2579C93.3482 59.2098 93.1883 59.1995 93.0332 59.228L71.4987 63.3003L62.2881 65.0451L52.403 66.915L49.2458 67.5127C49.061 67.547 48.871 67.542 48.6883 67.498C48.5056 67.4541 48.3343 67.3721 48.1858 67.2576L45.6504 65.29L46.5401 65.5041L48.4183 66.9606C48.5244 67.0425 48.6468 67.101 48.7773 67.1324C48.9078 67.1638 49.0435 67.1674 49.1756 67.1429L51.5133 66.7009L61.3984 64.831L71.2923 62.9603L92.9622 58.8609C93.147 58.8245 93.3375 58.8286 93.5206 58.8729L93.9761 59.5061ZM94.4941 60.4589L83.3397 106.264C83.2569 106.602 83.0424 106.894 82.7433 107.076C82.4442 107.257 82.0849 107.313 81.7442 107.232L1.01166 87.8036C0.671153 87.7213 0.377394 87.5081 0.194866 87.2108C0.0123379 86.9134 -0.0440494 86.5562 0.0380959 86.2176L11.1925 40.4127C11.244 40.1989 11.3489 40.0015 11.4977 39.8388C11.6464 39.676 11.834 39.5533 12.0432 39.4819C12.1976 39.428 12.3609 39.4035 12.5245 39.4099C12.7152 39.4154 12.9021 39.4643 13.0708 39.5528C13.1487 39.5895 13.2222 39.6349 13.2899 39.688L19.9156 44.8312L29.5382 52.3034L32.7619 54.8065L32.7612 54.8092L32.764 54.8099L44.5858 63.9837L46.5401 65.5041L48.4183 66.9606C48.5244 67.0425 48.6468 67.101 48.7773 67.1324C48.9078 67.1638 49.0435 67.1674 49.1756 67.1429L51.5133 66.7009L61.3984 64.831L71.2923 62.9603L92.9622 58.8609C93.147 58.8245 93.3375 58.8286 93.5206 58.8729C93.767 58.9327 93.9909 59.0617 94.1657 59.2444C94.2327 59.3162 94.2922 59.3944 94.3436 59.4779C94.5216 59.7725 94.5757 60.125 94.4941 60.4589ZM94.1262 60.3704C94.1592 60.2354 94.1613 60.0948 94.1325 59.9588C94.1037 59.8229 94.0446 59.6951 93.9597 59.5847C93.9521 59.5685 93.9409 59.5542 93.927 59.5427C93.9188 59.5293 93.9045 59.5174 93.8937 59.5034C93.7844 59.3903 93.6485 59.3059 93.4984 59.2579C93.3482 59.2098 93.1883 59.1995 93.0332 59.228L71.4987 63.3003L62.2881 65.0451L52.403 66.915L49.2458 67.5127C49.061 67.547 48.871 67.542 48.6883 67.498C48.5056 67.4541 48.3343 67.3721 48.1858 67.2576L45.6504 65.29L44.047 64.0448L32.665 55.2044L32.2265 54.8655L29.5398 52.779L19.9721 45.3513L13.0552 39.9816C12.95 39.9001 12.8286 39.8417 12.699 39.8105C12.6628 39.8017 12.626 39.7957 12.5889 39.7925C12.5566 39.7867 12.5238 39.7836 12.491 39.7832C12.3804 39.7822 12.2705 39.8 12.166 39.8359C12.0169 39.8875 11.8832 39.9753 11.7769 40.0914C11.6707 40.2075 11.5953 40.3481 11.5577 40.5006L0.40321 86.3054C0.373863 86.4255 0.368602 86.5501 0.387751 86.6721C0.406901 86.7942 0.450069 86.9113 0.514793 87.0167C0.579517 87.1222 0.664533 87.2139 0.764956 87.2866C0.865379 87.3594 0.979257 87.4117 1.10006 87.4407L81.8326 106.869C82.0761 106.927 82.333 106.887 82.5466 106.756C82.7603 106.626 82.9132 106.417 82.9718 106.175L94.1262 60.3704ZM62.2881 65.0451L52.403 66.915L49.2458 67.5127C49.061 67.547 48.871 67.542 48.6883 67.498C48.5056 67.4541 48.3343 67.3721 48.1858 67.2576L45.6504 65.29L46.5401 65.5041L48.4183 66.9606C48.5244 67.0425 48.6468 67.101 48.7773 67.1324C48.9078 67.1638 49.0435 67.1674 49.1756 67.1429L51.5133 66.7009L61.3984 64.831L62.2881 65.0451ZM62.2881 65.0451L52.403 66.915L49.2458 67.5127C49.061 67.547 48.871 67.542 48.6883 67.498C48.5056 67.4541 48.3343 67.3721 48.1858 67.2576L45.6504 65.29L46.5401 65.5041L48.4183 66.9606C48.5244 67.0425 48.6468 67.101 48.7773 67.1324C48.9078 67.1638 49.0435 67.1674 49.1756 67.1429L51.5133 66.7009L61.3984 64.831L62.2881 65.0451ZM62.2881 65.0451L52.403 66.915L49.2458 67.5127C49.061 67.547 48.871 67.542 48.6883 67.498C48.5056 67.4541 48.3343 67.3721 48.1858 67.2576L45.6504 65.29L46.5401 65.5041L48.4183 66.9606C48.5244 67.0425 48.6468 67.101 48.7773 67.1324C48.9078 67.1638 49.0435 67.1674 49.1756 67.1429L51.5133 66.7009L61.3984 64.831L62.2881 65.0451Z",
                              fill: "#3F3D56",
                            },
                          }),
                          _c("path", {
                            attrs: {
                              d: "M22.0513 78.8044C22.2331 78.0538 22.1081 77.2622 21.7035 76.6031C21.299 75.9441 20.648 75.4715 19.8934 75.289L9.70389 72.8369C8.94989 72.6583 8.1554 72.784 7.49444 73.1865C6.83348 73.589 6.35996 74.2355 6.17758 74.9844C5.99521 75.7333 6.11886 76.5235 6.52145 77.182C6.92404 77.8405 7.57274 78.3134 8.32546 78.4974L18.515 80.9494C19.27 81.1302 20.0663 81.0059 20.7293 80.6038C21.3922 80.2016 21.8677 79.5545 22.0513 78.8044Z",
                              fill: "#AB6E93",
                            },
                          }),
                          _c("path", {
                            attrs: {
                              d: "M134.658 70.2979C133.263 70.2979 132.132 69.1738 132.132 67.7872C132.132 66.4007 133.263 65.2766 134.658 65.2766C136.053 65.2766 137.184 66.4007 137.184 67.7872C137.184 69.1738 136.053 70.2979 134.658 70.2979Z",
                              fill: "white",
                            },
                          }),
                        ]
                      ),
                      _c("defs", [
                        _c("clipPath", { attrs: { id: "clip0_1576_50" } }, [
                          _c("rect", {
                            attrs: {
                              width: "208",
                              height: "177",
                              fill: "white",
                              transform: "matrix(-1 0 0 1 208 0)",
                            },
                          }),
                        ]),
                      ]),
                    ]
                  ),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "container-switch" },
                [
                  _c("ComponentSwitch", {
                    attrs: {
                      value:
                        _vm.notifications.inbox == true ||
                        _vm.notifications.inbox == "true",
                      size: "xxl",
                      onChange: _vm.handleChangeStateNotification,
                      id: "inbox",
                    },
                  }),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
      _c("div", { staticClass: "card card-echec card-page" }, [
        _c("header", [
          _c("i", { staticClass: "fa-solid fa-bell" }),
          _vm._v(
            "\n                    " +
              _vm._s(_vm.$t("dash.settings.notifications.page.title")) +
              "\n                "
          ),
        ]),
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "container-info" }, [
            _c("div", { staticClass: "notification-info" }, [
              _c("h4", {}, [
                _vm._v(
                  _vm._s(
                    _vm.$t("dash.settings.notifications.page.content.title")
                  )
                ),
              ]),
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.$t("dash.settings.notifications.page.content.subtitle")
                  )
                ),
              ]),
            ]),
            _c("div", { staticClass: "svg" }, [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "100%",
                    height: "100%",
                    viewBox: "0 0 211 193",
                    fill: "none",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M206.808 192.429L198.297 166.772C198.297 166.772 207.659 176.124 207.659 183.797L205.978 166.053C205.978 166.053 210.779 172.527 210.299 182.358C209.819 192.189 206.808 192.429 206.808 192.429Z",
                      fill: "#F1EDF5",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M24.0293 169.068L15.7227 144.028C15.7227 144.028 24.8594 153.154 24.8594 160.643L23.2195 143.326C23.2195 143.326 27.905 149.644 27.4364 159.239C26.9679 168.834 24.0293 169.068 24.0293 169.068Z",
                      fill: "#F1EDF5",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M153.682 180.622C153.697 197.094 120.991 192.027 80.9519 192.062C40.9126 192.097 8.70174 197.219 8.6875 180.747C8.67327 164.276 41.3669 160.665 81.4061 160.631C121.445 160.596 153.668 164.151 153.682 180.622Z",
                      fill: "#F1EDF5",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M125.62 158.377H120.386L117.895 138.209H125.62V158.377Z",
                      fill: "#A0616A",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M116.064 156.883H126.741V163.233H110.289V162.652C110.289 161.122 110.897 159.655 111.98 158.573C113.063 157.491 114.532 156.883 116.064 156.883Z",
                      fill: "#2F2E41",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M164.097 188.145H158.862L156.371 167.976H164.097V188.145Z",
                      fill: "#A0616A",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M154.54 186.651H165.217V193H148.766V192.419C148.766 190.889 149.374 189.422 150.457 188.34C151.54 187.258 153.009 186.651 154.54 186.651Z",
                      fill: "#2F2E41",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M188.242 128.228C188.604 127.79 188.866 127.278 189.008 126.727C189.15 126.177 189.17 125.603 189.066 125.044C188.961 124.485 188.736 123.956 188.405 123.494C188.074 123.032 187.646 122.648 187.15 122.369L174.992 72.8977L167.219 76.2386L181.679 124.073C181.266 124.936 181.183 125.92 181.447 126.84C181.711 127.759 182.304 128.55 183.113 129.063C183.922 129.575 184.891 129.773 185.836 129.619C186.782 129.465 187.638 128.971 188.242 128.228Z",
                      fill: "#A0616A",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M178.758 28.2463C178.324 27.7932 177.796 27.4406 177.211 27.2135C176.626 26.9863 175.998 26.89 175.372 26.9314C174.745 26.9728 174.136 27.1509 173.586 27.4531C173.036 27.7553 172.559 28.1743 172.189 28.6805L153.371 30.8385L156.234 38.0886L173.347 34.8893C174.24 35.4544 175.309 35.6727 176.352 35.503C177.395 35.3333 178.339 34.7873 179.006 33.9685C179.673 33.1496 180.016 32.1148 179.971 31.0602C179.925 30.0056 179.493 29.0043 178.758 28.2463Z",
                      fill: "#A0616A",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M147.75 123.098L155.961 184.657L166.181 182.556C166.181 182.556 164.678 137.723 169.788 132.319C174.898 126.914 163.216 117.446 163.216 117.446L147.75 123.098Z",
                      fill: "#2F2E41",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M151.146 106.142L147.374 111.794C147.374 111.794 118.328 99.7367 118.328 118.953C118.328 138.17 116.666 151.211 116.065 152.112C115.464 153.012 123.02 155.35 126.627 154.749C126.627 154.749 131.077 123.769 130.777 121.968C130.777 121.968 159.269 135.922 164.68 134.721C170.09 133.52 171.368 129.268 172.27 126.866C173.172 124.464 171.893 105.388 171.893 105.388L153.858 99.8907L151.146 106.142Z",
                      fill: "#2F2E41",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M151.652 72.2072L150.577 70.9184C150.577 70.9184 138.535 43.8535 143.265 36.5503C147.996 29.2471 168.64 28.1731 169.285 28.6027C169.93 29.0323 167.744 34.61 169.249 37.1876C169.249 37.1876 153.258 40.6508 152.182 41.0804C151.107 41.51 160.468 57.386 160.468 57.386L159.393 67.052L151.652 72.2072Z",
                      fill: "#B64985",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M172.727 58.8895C172.727 58.8895 161.545 60.1783 161.115 60.1783C160.685 60.1783 160.47 57.3859 160.47 57.3859L150.578 70.9183C150.578 70.9183 145.705 110.178 146.995 109.533C148.285 108.889 172.082 112.59 172.297 110.871C172.512 109.153 172.082 100.561 172.727 100.131C173.372 99.7016 183.909 73.0663 183.909 73.0663C183.909 73.0663 182.833 67.4815 179.178 65.5483C175.522 63.6151 172.727 58.8895 172.727 58.8895Z",
                      fill: "#B64985",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M180.468 69.4148L183.909 73.0664C183.909 73.0664 189.021 115.027 186.225 116.316C183.43 117.604 177.926 117.446 177.926 117.446L172.512 97.5536L180.468 69.4148Z",
                      fill: "#B64985",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M161.98 56.2323C167.446 56.2323 171.877 51.8058 171.877 46.3455C171.877 40.8852 167.446 36.4587 161.98 36.4587C156.513 36.4587 152.082 40.8852 152.082 46.3455C152.082 51.8058 156.513 56.2323 161.98 56.2323Z",
                      fill: "#A0616A",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M159.66 47.8882C159.526 45.8367 156.935 45.7664 154.877 45.747C152.819 45.7276 150.358 45.801 149.194 44.1059C148.424 42.9857 148.571 41.4305 149.207 40.2295C149.843 39.0284 150.889 38.1047 151.918 37.216C154.574 34.9218 157.311 32.6457 160.5 31.1772C163.689 29.7087 167.426 29.1154 170.733 30.2942C174.796 31.7422 180.288 39.1964 180.762 43.4791C181.236 47.7617 179.523 52.1276 176.634 55.3279C173.746 58.5282 167.135 57.2369 162.975 58.3754C165.504 54.7997 163.837 48.3026 159.786 46.6328L159.66 47.8882Z",
                      fill: "#2F2E41",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M71.448 175.775C84.5706 175.775 95.2085 165.149 95.2085 152.041C95.2085 138.932 84.5706 128.306 71.448 128.306C58.3255 128.306 47.6875 138.932 47.6875 152.041C47.6875 165.149 58.3255 175.775 71.448 175.775Z",
                      fill: "#AB6E93",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M55.5789 126.62C52.2859 126.62 49.0634 125.667 46.3014 123.875C43.5395 122.084 41.3565 119.532 40.0168 116.527L2.3133 31.7121C1.06436 28.9026 0.403815 25.8677 0.372279 22.7938C0.340743 19.7199 0.938878 16.6721 2.12992 13.8376C3.32096 11.0032 5.07975 8.44194 7.29816 6.31142C9.51658 4.1809 12.1478 2.52609 15.03 1.44869C17.9122 0.371286 20.9845 -0.105935 24.0582 0.0463625C27.1318 0.19866 30.1418 0.977254 32.9031 2.33429C35.6644 3.69132 38.1187 5.59813 40.1152 7.93749C42.1116 10.2769 43.608 12.9994 44.5124 15.9377L71.8143 104.641C72.5959 107.18 72.7705 109.867 72.3241 112.485C71.8777 115.104 70.8226 117.581 69.2437 119.719C67.6649 121.856 65.6061 123.594 63.2329 124.793C60.8597 125.991 58.2382 126.617 55.5789 126.62Z",
                      fill: "#AB6E93",
                    },
                  }),
                ]
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "container-switch" },
            [
              _c("ComponentSwitch", {
                attrs: {
                  value:
                    _vm.notifications.page == true ||
                    _vm.notifications.page == "true",
                  size: "xxl",
                  onChange: _vm.handleChangeStateNotification,
                  id: "page",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _c("div", { staticClass: "card card-echec card-source" }, [
        _c("header", [
          _c("i", { staticClass: "fa-solid fa-bell" }),
          _vm._v(
            "\n                    " +
              _vm._s(_vm.$t("dash.settings.notifications.source.title")) +
              "\n                "
          ),
        ]),
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "container-info" }, [
            _c("div", { staticClass: "notification-info" }, [
              _c("h4", {}, [
                _vm._v(
                  _vm._s(
                    _vm.$t("dash.settings.notifications.source.content.title")
                  )
                ),
              ]),
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "dash.settings.notifications.source.content.subtitle"
                    )
                  )
                ),
              ]),
            ]),
            _c("div", { staticClass: "svg" }, [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "100%",
                    height: "100%",
                    viewBox: "0 0 211 193",
                    fill: "none",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M206.808 192.429L198.297 166.772C198.297 166.772 207.659 176.124 207.659 183.797L205.978 166.053C205.978 166.053 210.779 172.527 210.299 182.358C209.819 192.189 206.808 192.429 206.808 192.429Z",
                      fill: "#F1EDF5",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M24.0293 169.068L15.7227 144.028C15.7227 144.028 24.8594 153.154 24.8594 160.643L23.2195 143.326C23.2195 143.326 27.905 149.644 27.4364 159.239C26.9679 168.834 24.0293 169.068 24.0293 169.068Z",
                      fill: "#F1EDF5",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M153.682 180.622C153.697 197.094 120.991 192.027 80.9519 192.062C40.9126 192.097 8.70174 197.219 8.6875 180.747C8.67327 164.276 41.3669 160.665 81.4061 160.631C121.445 160.596 153.668 164.151 153.682 180.622Z",
                      fill: "#F1EDF5",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M125.62 158.377H120.386L117.895 138.209H125.62V158.377Z",
                      fill: "#A0616A",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M116.064 156.883H126.741V163.233H110.289V162.652C110.289 161.122 110.897 159.655 111.98 158.573C113.063 157.491 114.532 156.883 116.064 156.883Z",
                      fill: "#2F2E41",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M164.097 188.145H158.862L156.371 167.976H164.097V188.145Z",
                      fill: "#A0616A",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M154.54 186.651H165.217V193H148.766V192.419C148.766 190.889 149.374 189.422 150.457 188.34C151.54 187.258 153.009 186.651 154.54 186.651Z",
                      fill: "#2F2E41",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M188.242 128.228C188.604 127.79 188.866 127.278 189.008 126.727C189.15 126.177 189.17 125.603 189.066 125.044C188.961 124.485 188.736 123.956 188.405 123.494C188.074 123.032 187.646 122.648 187.15 122.369L174.992 72.8977L167.219 76.2386L181.679 124.073C181.266 124.936 181.183 125.92 181.447 126.84C181.711 127.759 182.304 128.55 183.113 129.063C183.922 129.575 184.891 129.773 185.836 129.619C186.782 129.465 187.638 128.971 188.242 128.228Z",
                      fill: "#A0616A",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M178.758 28.2463C178.324 27.7932 177.796 27.4406 177.211 27.2135C176.626 26.9863 175.998 26.89 175.372 26.9314C174.745 26.9728 174.136 27.1509 173.586 27.4531C173.036 27.7553 172.559 28.1743 172.189 28.6805L153.371 30.8385L156.234 38.0886L173.347 34.8893C174.24 35.4544 175.309 35.6727 176.352 35.503C177.395 35.3333 178.339 34.7873 179.006 33.9685C179.673 33.1496 180.016 32.1148 179.971 31.0602C179.925 30.0056 179.493 29.0043 178.758 28.2463Z",
                      fill: "#A0616A",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M147.75 123.098L155.961 184.657L166.181 182.556C166.181 182.556 164.678 137.723 169.788 132.319C174.898 126.914 163.216 117.446 163.216 117.446L147.75 123.098Z",
                      fill: "#2F2E41",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M151.146 106.142L147.374 111.794C147.374 111.794 118.328 99.7367 118.328 118.953C118.328 138.17 116.666 151.211 116.065 152.112C115.464 153.012 123.02 155.35 126.627 154.749C126.627 154.749 131.077 123.769 130.777 121.968C130.777 121.968 159.269 135.922 164.68 134.721C170.09 133.52 171.368 129.268 172.27 126.866C173.172 124.464 171.893 105.388 171.893 105.388L153.858 99.8907L151.146 106.142Z",
                      fill: "#2F2E41",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M151.652 72.2072L150.577 70.9184C150.577 70.9184 138.535 43.8535 143.265 36.5503C147.996 29.2471 168.64 28.1731 169.285 28.6027C169.93 29.0323 167.744 34.61 169.249 37.1876C169.249 37.1876 153.258 40.6508 152.182 41.0804C151.107 41.51 160.468 57.386 160.468 57.386L159.393 67.052L151.652 72.2072Z",
                      fill: "#B64985",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M172.727 58.8895C172.727 58.8895 161.545 60.1783 161.115 60.1783C160.685 60.1783 160.47 57.3859 160.47 57.3859L150.578 70.9183C150.578 70.9183 145.705 110.178 146.995 109.533C148.285 108.889 172.082 112.59 172.297 110.871C172.512 109.153 172.082 100.561 172.727 100.131C173.372 99.7016 183.909 73.0663 183.909 73.0663C183.909 73.0663 182.833 67.4815 179.178 65.5483C175.522 63.6151 172.727 58.8895 172.727 58.8895Z",
                      fill: "#B64985",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M180.468 69.4148L183.909 73.0664C183.909 73.0664 189.021 115.027 186.225 116.316C183.43 117.604 177.926 117.446 177.926 117.446L172.512 97.5536L180.468 69.4148Z",
                      fill: "#B64985",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M161.98 56.2323C167.446 56.2323 171.877 51.8058 171.877 46.3455C171.877 40.8852 167.446 36.4587 161.98 36.4587C156.513 36.4587 152.082 40.8852 152.082 46.3455C152.082 51.8058 156.513 56.2323 161.98 56.2323Z",
                      fill: "#A0616A",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M159.66 47.8882C159.526 45.8367 156.935 45.7664 154.877 45.747C152.819 45.7276 150.358 45.801 149.194 44.1059C148.424 42.9857 148.571 41.4305 149.207 40.2295C149.843 39.0284 150.889 38.1047 151.918 37.216C154.574 34.9218 157.311 32.6457 160.5 31.1772C163.689 29.7087 167.426 29.1154 170.733 30.2942C174.796 31.7422 180.288 39.1964 180.762 43.4791C181.236 47.7617 179.523 52.1276 176.634 55.3279C173.746 58.5282 167.135 57.2369 162.975 58.3754C165.504 54.7997 163.837 48.3026 159.786 46.6328L159.66 47.8882Z",
                      fill: "#2F2E41",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M71.448 175.775C84.5706 175.775 95.2085 165.149 95.2085 152.041C95.2085 138.932 84.5706 128.306 71.448 128.306C58.3255 128.306 47.6875 138.932 47.6875 152.041C47.6875 165.149 58.3255 175.775 71.448 175.775Z",
                      fill: "#AB6E93",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M55.5789 126.62C52.2859 126.62 49.0634 125.667 46.3014 123.875C43.5395 122.084 41.3565 119.532 40.0168 116.527L2.3133 31.7121C1.06436 28.9026 0.403815 25.8677 0.372279 22.7938C0.340743 19.7199 0.938878 16.6721 2.12992 13.8376C3.32096 11.0032 5.07975 8.44194 7.29816 6.31142C9.51658 4.1809 12.1478 2.52609 15.03 1.44869C17.9122 0.371286 20.9845 -0.105935 24.0582 0.0463625C27.1318 0.19866 30.1418 0.977254 32.9031 2.33429C35.6644 3.69132 38.1187 5.59813 40.1152 7.93749C42.1116 10.2769 43.608 12.9994 44.5124 15.9377L71.8143 104.641C72.5959 107.18 72.7705 109.867 72.3241 112.485C71.8777 115.104 70.8226 117.581 69.2437 119.719C67.6649 121.856 65.6061 123.594 63.2329 124.793C60.8597 125.991 58.2382 126.617 55.5789 126.62Z",
                      fill: "#AB6E93",
                    },
                  }),
                ]
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "container-switch" },
            [
              _c("ComponentSwitch", {
                attrs: {
                  value:
                    _vm.notifications.source == true ||
                    _vm.notifications.source == "true",
                  size: "xxl",
                  onChange: _vm.handleChangeStateNotification,
                  id: "source",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm.isReportingV2Env
        ? _c("div", { staticClass: "card card-newsletter" }, [
            _c("header", [
              _c("i", { staticClass: "fa-solid fa-envelope" }),
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.$t("dash.settings.notifications.newsletter.title")
                  ) +
                  "\n                "
              ),
            ]),
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "container-info" }, [
                _c("div", { staticClass: "notification-info" }, [
                  _c("h4", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "dash.settings.notifications.newsletter.content.title"
                        )
                      )
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "dash.settings.notifications.newsletter.content.subtitle"
                        )
                      )
                    ),
                  ]),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "container-switch" },
                [
                  _c("ComponentSwitch", {
                    attrs: {
                      value:
                        _vm.notifications.reporting == true ||
                        _vm.notifications.reporting == "true",
                      size: "xxl",
                      onChange: _vm.handleChangeStateNotification,
                      id: "reporting",
                    },
                  }),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }